import * as PlansActionTypes from 'actiontypes/plans';
import {
  clearCache,
} from 'actions/storylet';
import PlansService from 'services/PlansService';
import { IEditPlanRequestData, IPlan, IPlansService } from 'types/plans';
import { Dispatch } from 'redux';

/** ----------------------------------------------------------------------------
* SAVE EDIT PLAN
-----------------------------------------------------------------------------*/
export default saveEditPlan(new PlansService());

export function saveEditPlan(service: IPlansService) {
  return (planData: IEditPlanRequestData) => (dispatch: Dispatch) => {
    dispatch(editPlanRequest());
    return service.editPlan(planData).then((response) => {
      dispatch(editPlanSuccess(response.data));
      dispatch(clearCache());
    }).catch(() => {
      dispatch(editPlanFailure());
    });
  };
}

export const editPlanRequest = () => ({
  type: PlansActionTypes.SAVE_EDIT_REQUESTED,
});

export const editPlanSuccess = (data: { active: IPlan[], complete: IPlan[] }) => ({
  type: PlansActionTypes.SAVE_EDIT_SUCCESS,
  payload: {
    activePlans: data.active,
    completePlans: data.complete,
  },
});

export const editPlanFailure = () => ({ type: PlansActionTypes.SAVE_EDIT_FAILURE });